export function formatText(text: string): string {
  if (text.toLowerCase() === 'api') return 'API';

  return text
    .split(/[_:]/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}
